(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/components/bingo-card/assets/javascripts/bingo-card.js') >= 0) return;  svs.modules.push('/modules/bingo-react/components/bingo-card/assets/javascripts/bingo-card.js');
"use strict";


const _React = React,
  useMemo = _React.useMemo;
const _svs$bingo_react$comp = svs.bingo_react.components.bingoCard,
  CardImage = _svs$bingo_react$comp.CardImage,
  Host = _svs$bingo_react$comp.Host,
  InfoItem = _svs$bingo_react$comp.InfoItem,
  TopBadge = _svs$bingo_react$comp.TopBadge;
const formatCurrency = svs.utils.format.Currency;
const startBingoGame = svs.bingo_react.components.startBingoGame;
const _svs$bingo_react$comp2 = svs.bingo_react.components.common,
  getBingoCardAriaLabel = _svs$bingo_react$comp2.accessibilityHelpers.getBingoCardAriaLabel,
  PlayMode = _svs$bingo_react$comp2.constants.PlayMode;
const useStartTimer = svs.bingo_react.components.useStartTimer;
const _svs$ui$ReactCard = svs.ui.ReactCard,
  Card = _svs$ui$ReactCard.Card,
  CardBody = _svs$ui$ReactCard.CardBody;

const renderHost = false;
const BingoCard = _ref => {
  let _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    invertedColors = _ref.invertedColors,
    promoPosition = _ref.promoPosition,
    _ref$gameData = _ref.gameData,
    jackpotAmount = _ref$gameData.jackpotAmount,
    badgeText = _ref$gameData.badgeText,
    gameId = _ref$gameData.id,
    startTime = _ref$gameData.startTime,
    status = _ref$gameData.status,
    title = _ref$gameData.title,
    subTitle = _ref$gameData.subTitle,
    players = _ref$gameData.players,
    price = _ref$gameData.price,
    host = _ref$gameData.host,
    playMode = _ref$gameData.playMode,
    lastWinTimestamp = _ref.lastWinTimestamp;
  const classList = ['bingo-card'];
  classList.push(className);
  const isMultiPlayer = useMemo(() => playMode === PlayMode.Multi, [playMode]);
  const timer = useStartTimer(startTime, status);
  const ariaLabel = useMemo(() => getBingoCardAriaLabel({
    title,
    bingoCardPrice: price,
    players: isMultiPlayer ? players : null,
    addTimer: isMultiPlayer,
    timer,
    status,
    jackpotAmount
  }), [title, price, players, isMultiPlayer, timer, status, jackpotAmount]);
  if (invertedColors) {
    classList.push('bingo-card--inverted');
  }
  let Badge = () => null;
  if (jackpotAmount || badgeText) {
    const label = jackpotAmount ? "".concat(formatCurrency(jackpotAmount), " kr") : badgeText;
    Badge = () => React.createElement(TopBadge, {
      color: jackpotAmount ? 'gold' : 'red',
      label: label
    });
  }
  return React.createElement(Card, {
    "aria-label": ariaLabel,
    className: classList.join(' '),
    Component: "a",
    "data-area-name": promoPosition,
    "data-impression": "true",
    "data-impression-tracking": "bingo-card-".concat(promoPosition),
    onClick: () => startBingoGame(gameId, promoPosition),
    onKeyDown: e => e.key === 'Enter' && startBingoGame(gameId),
    role: "button",
    tabIndex: 0
  }, React.createElement(CardBody, {
    className: "bingo-card__body"
  }, React.createElement(Badge, null), React.createElement(CardImage, {
    badgeText: badgeText,
    gameId: gameId,
    lastWinTimestamp: lastWinTimestamp,
    renderHoverOverlay: false,
    showTimer: playMode !== 'SINGLEUSER',
    startTime: startTime,
    status: status,
    subTitle: subTitle,
    title: title
  }), React.createElement("div", {
    className: "bingo-card-info".concat(invertedColors ? ' bingo-card-info--inverted' : '')
  }, React.createElement("div", {
    className: "bingo-card-info-title"
  }, React.createElement("h3", {
    className: "bingo-card-info-title__title"
  }, title), React.createElement("h4", {
    className: "bingo-card-info-title__subtitle"
  }, subTitle)), host && renderHost && React.createElement(Host, {
    imgSrc: host.imgSrc,
    name: host.name
  }), React.createElement("div", {
    className: "bingo-card-info__info"
  }, React.createElement(InfoItem, {
    bold: true,
    icon: "".concat(playMode === 'SINGLEUSER' ? 'user' : 'players'),
    label: "".concat(playMode === 'SINGLEUSER' ? '' : "".concat(players, " st"))
  }), React.createElement(InfoItem, {
    icon: "money",
    label: "".concat(price, " kr")
  })))));
};
setGlobal('svs.bingo_react.components.bingoCard.BingoCard', BingoCard);

 })(window);